import React, { useEffect, useState } from 'react';
import '../Operations/DspDetails.css';
import { useLocation } from 'react-router';
import ViewStoreDetails from './ViewStoreDetails';
import ViewOnBoardedUsers from './ViewOnBoardedUsers';
import ViewRequestIncentives from './ViewRequestIncentives';
import ViewSettlements from './ViewSettlements';


function StoresDetailsDashBoard() {
    const [activeTab, setActiveTab] = useState(()=>{
        let savedFilters=localStorage.getItem("storeDashboardTabFilters");
        if(savedFilters){
            let parsedFilters = JSON.parse(savedFilters);
            return parsedFilters;
        }
        return 'details'
    });


    const location = useLocation();
    const [store, setStore] = useState(location.state?.store)
    const tabs = ['details', 'Onboarded Users', 'Request Incentives', "Settlements"];

    useEffect(()=>{
    localStorage.setItem("storeDashboardTabFilters",JSON.stringify(activeTab));
    },[activeTab]);

    return (
        <div style={{ backgroundColor: "rgb(236, 239, 243)", overflow: "hidden" }} className='flex flex-col gap-5 h-[100%]  px-[20px] py-[50px]'>
            <div className="drone-tabs ">
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        className={`tab-button ${activeTab === tab ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                ))}
            </div>
            <div className="flex-grow overflow-y-auto">
                {activeTab === "details" ? (
                    <ViewStoreDetails hideBankDetails={true} store={store} callback={(store) => {
                        setStore(store);
                    }} />
                ) : activeTab === "Onboarded Users" ? <ViewOnBoardedUsers store={store} />
                    : activeTab === "Request Incentives" ? <ViewRequestIncentives store={store} /> :
                        activeTab === "Settlements" ? <ViewSettlements store={store} /> :
                            null}
            </div>
        </div>
    );
}

export default StoresDetailsDashBoard;